import React from "react";
import { Col, Container, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import QueryString from "query-string";
// import PropTypes from "prop-types";
import Table from "./components/DataTable";
import { PAID_JOBS_PATH } from "../../URLs";

const DataTable = props => {
  const query = QueryString.parse(props.location.search);
  console.log(query);
  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">
            {query.company && query.company}{" "}
            {window.location.pathname === PAID_JOBS_PATH && "Paid"} Jobs
          </h3>
          {/* <h3 className="page-subhead subhead">Use this elements, if you want to show some hints or additional
          information
        </h3> */}
        </Col>
      </Row>
      <Row>
        <Table queryObject={query} />
      </Row>
    </Container>
  );
};

// DataTable.propTypes = {
//   t: PropTypes.func.isRequired
// };

export default withTranslation("common")(DataTable);
